export default __webpack_public_path__ + "static/media/bg-participacao.785beaff.png";